import "./App.css";
import "./assets/css/global.css"
import Store from "./contexts/Store";

import MainRouter from "./routing/routers/MainRouter";

function App() {
	// useEffect(() => {
	// 	const initialValue = document.body.style.zoom;

	// 	// Change zoom level on mount
	// 	document.body.style.zoom = "80%";

	// 	return () => {
	// 		// Restore default value
	// 		document.body.style.zoom = initialValue;
	// 	};
	// }, []);

	return (
		<Store>
			<MainRouter />
		</Store>
	);
}

export default App;
